import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { prefetchSlackUsers } from 'apps/app/src/hooks/requests/use-slack';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { MenuItemShareInvoiceToSlack } from './MenuItemShareInvoiceToSlack';

type DynamicInvoiceHeaderDotMenuProps = {
  onPurchaseOrderModalOpen: () => void;
  onNotesModalOpen: () => void;
  onSyncInvoiceToNetSuite: () => void;
  invoiceId: string;
  isSlackShareEnabled: boolean;
};

export function DynamicInvoiceHeaderDotMenu({
  onPurchaseOrderModalOpen,
  onNotesModalOpen,
  onSyncInvoiceToNetSuite,
  invoiceId,
  isSlackShareEnabled,
}: DynamicInvoiceHeaderDotMenuProps) {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();
  const queryClient = useQueryClient();

  const handleOnHover = useCallback(async () => {
    if (isSlackShareEnabled) {
      await prefetchSlackUsers(queryClient);
    }
  }, [isSlackShareEnabled]);
  
  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        onMouseOver={handleOnHover}
      >
        <VyIcon
          icon="DotsMenu"
          style={{ transform: 'rotate(90deg)' }}
        />
      </IconButton>
      <div className="relative">
        <Menu
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={isOpen}
          anchorEl={anchorElement}
          onClose={handleMenuClose}
          slotProps={{
            paper: {
              className: 'max-w-[225px] w-full',
            },
          }}
        >
          <MenuItem onClick={onPurchaseOrderModalOpen}>
            <Typography>Add PO</Typography>
          </MenuItem>

          <MenuItem onClick={onNotesModalOpen}>Add details</MenuItem>

          <MenuItem onClick={onSyncInvoiceToNetSuite}>
            Sync to NetSuite
          </MenuItem>

          {isSlackShareEnabled && <MenuItemShareInvoiceToSlack invoiceId={invoiceId} />}
        </Menu>
      </div>
    </>
  );
}
